import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiStar,FiShield,FiAward}=FiIcons;

const TrustRow=()=> {
  const trustMarkers=[
    {icon: FiStar,text: "Practical AI mastery",subtext: "",color: "text-yellow-500"},
    {icon: FiShield,text: "Trusted by Gen X Professionals",subtext: "",color: "text-blue-500"},
    {icon: FiAward,text: "Proven results for",subtext: "Gen X professionals",color: "text-purple-500"}
  ];

  const peopleImages=[
    {url: "https://cdn1.sharemyimage.com/smi/2025/10/11/GenXDojoSiteManHeadshot1.jpeg",name: "Michael Long",role: "Marketing Director"},
    {url: "https://cdn1.sharemyimage.com/smi/2025/10/11/GenXDojoSiteManHeadshot2.jpeg",name: "James Rodriguez",role: "Operations Manager"},
    {url: "https://cdn1.sharemyimage.com/smi/2025/10/11/GenXDojoSiteWomanHeadshot1.jpeg",name: "Shanice Williams",role: "Small Business Owner"}
  ];

  return (
    <section className="py-16 bg-white dark:bg-slate-900 border-b-4 border-slate-200 dark:border-slate-700">
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-8 lg:px-12 xl:px-16">
        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
          className="flex flex-col md:flex-row items-center justify-center space-y-8 md:space-y-0 md:space-x-16 mb-16"
        >
          {trustMarkers.map((marker,index)=> (
            <motion.div
              key={index}
              initial={{opacity: 0,scale: 0.9}}
              whileInView={{opacity: 1,scale: 1}}
              transition={{duration: 0.5,delay: index * 0.1}}
              viewport={{once: true}}
              className="flex items-center space-x-4 bg-gradient-to-r from-slate-50 to-slate-100 dark:from-slate-800 dark:to-slate-700 p-6 rounded-2xl border-4 border-slate-200 dark:border-slate-600"
            >
              <SafeIcon icon={marker.icon} className={`w-12 h-12 ${marker.color}`} />
              <div>
                <div className="font-bold text-2xl text-slate-800 dark:text-white">{marker.text}</div>
                {marker.subtext && (
                  <div className="text-lg text-slate-600 dark:text-slate-400 font-medium">{marker.subtext}</div>
                )}
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Smiling People Cards Section */}
        <div className="flex justify-center flex-wrap gap-8">
          {peopleImages.map((person,index)=> (
            <motion.div
              key={index}
              initial={{opacity: 0,scale: 0.9}}
              whileInView={{opacity: 1,scale: 1}}
              transition={{duration: 0.5,delay: 0.4 + index * 0.1}}
              viewport={{once: true}}
              whileHover={{scale: 1.05,y: -5}}
              className="group"
            >
              <div className="bg-gradient-to-br from-white to-slate-50 dark:from-slate-800 dark:to-slate-700 p-4 rounded-2xl border-4 border-amber-200 dark:border-amber-600 shadow-xl hover:shadow-2xl transition-all duration-300">
                <div className="relative overflow-hidden rounded-xl mb-3">
                  <img 
                    src={person.url} 
                    alt={`${person.name}, ${person.role}`} 
                    className="w-32 h-44 object-cover transition-transform duration-300 group-hover:scale-110" 
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <div className="text-center">
                  <h3 className="font-bold text-lg text-slate-800 dark:text-white mb-1">{person.name}</h3>
                  <p className="text-sm text-slate-600 dark:text-slate-400 font-medium">{person.role}</p>
                  <div className="mt-2 flex justify-center">
                    <SafeIcon icon={FiStar} className="w-4 h-4 text-yellow-400 fill-current" />
                    <SafeIcon icon={FiStar} className="w-4 h-4 text-yellow-400 fill-current" />
                    <SafeIcon icon={FiStar} className="w-4 h-4 text-yellow-400 fill-current" />
                    <SafeIcon icon={FiStar} className="w-4 h-4 text-yellow-400 fill-current" />
                    <SafeIcon icon={FiStar} className="w-4 h-4 text-yellow-400 fill-current" />
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustRow;